import { render, staticRenderFns } from "./ManageApprovers.vue?vue&type=template&id=dd5246e2"
import script from "./ManageApprovers.vue?vue&type=script&lang=js"
export * from "./ManageApprovers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports